exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-16d13416]{font-size:15px;text-align:justify}img[data-v-16d13416]{width:100%}hr[data-v-16d13416]{margin:40px 0}", ""]);

// exports
